export default {
  install(Vue) {
    Vue.directive('no-context', {
      inserted(el) {
        const input = findInput(el);
        if (!input) return;

        const handler = e => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        };

        // 👇 CAPTURE = true (clave)
        input.addEventListener('contextmenu', handler, true);

        input.__noContextHandler__ = handler;
      },

      unbind(el) {
        const input = findInput(el);
        if (input && input.__noContextHandler__) {
          input.removeEventListener(
            'contextmenu',
            input.__noContextHandler__,
            true
          );
          delete input.__noContextHandler__;
        }
      }
    });

    function findInput(el) {
      if (!(el instanceof HTMLElement)) return null;

      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
        return el;
      }

      return el.querySelector?.('input, textarea') || null;
    }
  }
};